import React from 'react';
import { bonos, bonosTotalValue } from '../data/bonos';
import { Emoji } from './Emoji';
export function Bonos() {
  return <section className="w-full bg-forest-800 py-14 sm:py-16" data-id="element-16" data-mp="2hdcya1siix0d">
      <div className="mx-auto w-full max-w-content px-4 text-center sm:px-6" data-id="element-17" data-mp="2leeue9r4usy4">
        <h2 className="inline-flex flex-wrap items-center justify-center gap-2 font-display text-[clamp(1.5rem,6vw,2.25rem)] font-extrabold uppercase leading-[1.08] tracking-tight text-cream sm:gap-3" data-id="element-18" data-mp="2lcc0hemv0fo4">
          <Emoji symbol="🎁" className="text-3xl sm:text-4xl" data-id="element-19" data-mp="3032pyg0zb2o2" />
          6 Bonos Estratégicos
        </h2>
        <p className="mt-3 font-display text-xs font-extrabold uppercase tracking-[0.16em] text-lime-400 sm:text-sm" data-id="element-20" data-mp="352fauv8ahzo0">
          Siempre incluidos
        </p>
        <p className="mx-auto mt-4 max-w-xl text-[14px] leading-relaxed text-cream/70 sm:text-[15px]" data-id="element-21" data-mp="392y66z9e5nuy">
          Porque el sistema no termina en las recetas.
        </p>

        <ul className="mt-10 grid gap-4 text-left sm:gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-22" data-mp="1eqrjb374ximt">
          {bonos.map(bono => <li key={bono.index} className="h-full" data-id="element-23" data-mp="3e5c224h666ie">
              <article className="flex h-full flex-col rounded-2xl border-2 border-lime-500 bg-forest-950 px-5 py-5 shadow-[0_0_20px_-6px_rgba(34,197,94,0.5)] sm:px-6" data-id="element-24" data-mp="39cr9t7dww1gz">
                <p className="font-display text-3xl font-black leading-none text-lime-400" data-id="element-25" data-mp="34bv5wttk8fbk">
                  {bono.index}
                </p>
                <p className="mt-3 inline-flex items-center gap-2 font-display text-[11px] font-extrabold uppercase tracking-[0.16em] text-lime-500" data-id="element-26" data-mp="wg1c83yaxxt">
                  <Emoji symbol="🎁" data-id="element-27" data-mp="3s1xydb1dznap" />
                  Bono {Number(bono.index)}
                </p>
                <h3 className="mt-3 flex items-center gap-2 font-display text-[15px] font-extrabold uppercase leading-snug tracking-tight text-cream sm:text-base" data-id="element-28" data-mp="3n6io0t2l89j1">
                  <Emoji symbol={bono.emoji} data-id="element-29" data-mp="2br3pvlyn7bmc" />
                  <span className="min-w-0" data-id="element-30" data-mp="26qfs8hfwrwj5">{bono.title}</span>
                </h3>
                <p className="mt-3 text-[13px] leading-relaxed text-cream/70 sm:text-[14px]" data-id="element-31" data-mp="26ssgtdg69556">
                  {bono.description}
                </p>
                <p className="mt-auto flex flex-wrap items-center gap-3 pt-6" data-id="element-32" data-mp="12rkgs93ghcd6">
                  <span className="text-sm text-cream/45 line-through" data-id="element-33" data-mp="otcc1f06h6rg">
                    {bono.value}
                  </span>
                  <span className="rounded-full bg-lime-500 px-3 py-1 font-display text-xs font-extrabold uppercase tracking-wide text-forest-950" data-id="element-34" data-mp="tqm7bba90cn7">
                    Gratis
                  </span>
                </p>
              </article>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-xl rounded-2xl border-2 border-gold/40 bg-forest-900 px-5 py-6 sm:px-7 sm:py-7" data-id="element-35" data-mp="63e4r147fhov">
          <p className="font-display text-base font-bold text-cream sm:text-lg" data-id="element-36" data-mp="b1xuzdptzfn1">
            Valor total de los 6 bonos
          </p>
          <p className="mt-2 font-display text-2xl text-cream/50 line-through sm:text-3xl" data-id="element-37" data-mp="138jc2oj2rf8">
            {bonosTotalValue}
          </p>
          <p className="mt-2 font-display text-lg font-extrabold text-gold sm:text-xl" data-id="element-38" data-mp="3dnvt7tox3ne7">
            → Gratis con tu Mega Pack
          </p>
        </div>
      </div>
    </section>;
}